<template>
  <el-dialog :visible.sync="dialogVisible" width="30%" :show-close="false" :fullscreen="true" @close="handleClose">
    <div class="diaInner" id="diaInner">
      <h3 class="diainner_title">
        动火安全作业证
        <div class="diainner_title_num">编号：{{ message.no }}</div>
      </h3>
      <table border="1">
        <tr>
          <td class="title" :colspan="2">申请单位</td>
          <td :colspan="3">{{ message.applicant?.contrName }}</td>
          <!-- <td class="title">申请人</td>
          <td>{{ getUserName(message.applyUserId) }}</td> -->
          <td class="title" :colspan="1">作业申请时间</td>
          <td :colspan="3">{{ message.applyTime }}</td>
        </tr>
        <tr>
          <td class="title" :colspan="2">作业内容</td>
          <td :colspan="3">{{ message.businessJson.content }}</td>
          <td class="title" :colspan="1">动火地点</td>
          <td :colspan="3">{{ message.place }}</td>
        </tr>
        <tr>
          <td class="title" :colspan="2">动火作业级别</td>
          <td :colspan="7">
            {{ riskGradeArr[message.riskGrade] }}
          </td>
        </tr>
        <tr>
          <td class="title" :colspan="2">动火方式</td>
          <td :colspan="7">{{ message.businessJson.mode }}</td>
        </tr>

        <tr>
          <td class="title" :colspan="2">作业负责人</td>
          <td :colspan="7">{{ getUserName(message.reviewEmpId) }}</td>
        </tr>
        <template v-for="(item1, index) in message.businessJson.playFire || []">
          <tr>
            <td :key="index" :colspan="2" v-if="index === 0" class="title"
              :rowspan="message.businessJson.playFire.length">动火人</td>
            <td>{{ getUserName(message.jobExecutorEmpId) }}</td>
            <td v-if="index === 0" class="title" :rowspan="message.businessJson.playFire.length">特殊工种类别</td>
            <td :colspan="2">{{ item1.stw }}</td>
            <td v-if="index === 0" class="title" :rowspan="message.businessJson.playFire.length">工种证号</td>
            <td :colspan="2">{{ item1.wtcNo }}</td>
          </tr>
        </template>
        <!--动火分析-->
        <tr v-if="message.businessJson.analysis">
          <td :colspan="2" class="title">分析时间</td>
          <td :colspan="2" class="title">代表性气体</td>
          <td :colspan="2" class="title">分析结果（%）</td>
          <td :colspan="3" class="title">分析人</td>
        </tr>
        <template v-for="(item2, index2) in message.businessJson.analysis || []">
          <tr>
            <td :colspan="2" :key="index2">{{ item2.time }}</td>
            <td :colspan="2">{{ item2.position }}</td>
            <td :colspan="2">{{ item2.result }}</td>
            <td :colspan="3">{{ getUserName(item2.assayerId) }}</td>
          </tr>
        </template>
        <tr>
          <td :colspan="2" class="title">危险辨识结果</td>
          <td :colspan="7">{{ getDanger(message.businessJson.hi) }}</td>
        </tr>
        <tr>
          <td class="title" :colspan="2">动火作业实施时间</td>
          <td :colspan="7">{{ message.actualStartTime }} - {{ message.actualEndTime }}</td>
        </tr>
        <tr>
          <td class="title" :colspan="2">涉及的其他特殊作业及编号</td>
          <td :colspan="7">{{ formatPreWorkInfo() }}</td>
        </tr>
        <tr>
          <td class="title">序号</td>
          <td class="title" :colspan="5">安全措施</td>
          <td class="title" :colspan="2">是否涉及</td>
          <td class="title">确认人</td>
        </tr>
        <tr v-for="(item3, index3) in message.businessJson.sms" :key="index3 + '-' + item3.confirmorId">
          <td>{{ index3 + 1 }}</td>
          <td :colspan="5" class="keepLeft">{{ item3.measures }}</td>
          <td :colspan="2">{{ item3.isInvolve == 1 ? '是' : '否' }}</td>
          <td><i v-html="getSignatureImg(item3.orderNo, 40)" /></td>
        </tr>
        <tr>
          <td :colspan="2" class="title">安全交底人</td>
          <td :colspan="2">{{ getUserName(message.businessJson.aqjdrId) }}</td>
          <td :colspan="2" class="title">接受交底人</td>
          <td :colspan="3">{{ getUserName(message.businessJson.jsjdrId) }}</td>
        </tr>
        <tr>
          <td :colspan="2" class="title">动火措施初审人</td>
          <td :colspan="2">{{ getUserName(message.businessJson.cscsrId) }}</td>
          <td :colspan="2" class="title">监护人</td>
          <td :colspan="3">{{ getUserName(message.businessJson.jhrId) }}</td>
        </tr>
        <tr>
          <td :colspan="9">
            <div class="fireplayidea_title">作业负责人意见</div>
            <div class="fireplayidea_cont">{{ message.businessJson.companyChargerComment }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(message.businessJson.companyChargerOrder, 60)" /></span>
              <span>签字时间：{{ message.businessJson.companyChargerTime }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td :colspan="9">
            <div class="fireplayidea_title">所在单位意见</div>
            <div class="fireplayidea_cont">{{ message.businessJson.branchChargerComment }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(message.businessJson.branchChargerOrder, 60)" /></span>
              <span>签字时间：{{ message.businessJson.branchChargerTime }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td :colspan="9">
            <div class="fireplayidea_title">安全管理部门意见</div>
            <div class="fireplayidea_cont">{{ message.businessJson.safetyDeptUserComment }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(message.businessJson.safetyDeptUserOrder, 60)" /> </span>
              <span>签字时间：{{ message.businessJson.safetyDeptUserTime }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td :colspan="9">
            <div class="fireplayidea_title">动火审批人意见</div>
            <div class="fireplayidea_cont">{{ message.businessJson.fireApproverComment }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(message.businessJson.fireApproverOrder, 60)" /></span>
              <span>签字时间：{{ message.businessJson.fireApproverTime }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td :colspan="9">
            <div class="fireplayidea_title">动火前，岗位顶班班长验票情况</div>
            <div class="fireplayidea_cont">{{ message.businessJson.checkTicketUserComment }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(message.businessJson.checkTicketUserOrder, 60)" /></span>
              <span>签字时间：{{ message.businessJson.checkTicketUserTime }}</span>
            </div>
          </td>
        </tr><!--TODO 新增 动火前，岗位顶班班长验票-->
        <tr>
          <td :colspan="9">
            <div class="fireplayidea_title">完工验收</div>
            <div class="fireplayidea_cont">{{ message.acceptanceOpinion }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(0, 60)" /></span>
              <span>签字时间：{{ message.acceptanceTime }}</span>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <span slot="footer" class="diaFooter">
      <el-button @click="handleClose" size="small">取 消</el-button>
      <el-button v-if="!isWork" type="primary" v-print="'#diaInner'" size="small">打 印</el-button>
    </span>
  </el-dialog>
</template>

<script>
import signatureImg from "@/assets/img/签字.png";

export default {
  name: 'PremiumFirePlayer',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    message: {
      type: Object,
      default: {}
    },
    userList: {
      type: Array,
      default: []
    },
    isWork: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    //console.log('message:', this.message)
  },
  data() {
    return {
      dangerArr: [
        { id: 'A', name: '火灾爆炸' },
        { id: 'B', name: '中毒和窒息' },
        { id: 'C', name: '触电' },
        { id: 'D', name: '灼烫' },
        { id: 'E', name: '机械伤害' },
        { id: 'F', name: '高处坠落' },
        { id: 'G', name: '物体打击' },
        { id: 'H', name: '坍塌' },
        { id: 'I', name: '其它' },
      ],
      riskGradeArr: ['一级', '二级', '特级']
    }
  },
  methods: {
    formatPreWorkInfo() {
      if (!this.message.preWorkInfo) {
        return
      }
      let str = []
      let data = JSON.parse(this.message.preWorkInfo)
      for (var i = 0; i < data.length; i++) {
        let element = data[i]
        str.push(`${element.name}(${element.no})`)
      }
      str = str.join(',')
      return str
    },
    handleClose() {
      this.$emit('componentResult', false)
    },
    getUserName(id) {
      for (let i in this.userList) {
        if (Number(id) === this.userList[i].id) {
          return this.userList[i].name
        }
      }
    },

    // 危险辨识数据
    getDanger(row) {
      if (row && row.length > 0) {
        let arr = []
        for (let i in row) {
          for (let j in this.dangerArr) {
            if (row[i] === this.dangerArr[j].id) {
              arr.push(this.dangerArr[j].name)
            }
          }
        }
        return arr.join('、')
      } else {
        return '/'
      }
    },
    getSignatureImg(orderNum, height = 40) {
      let signatureImg = require('@/assets/img/签字.png');
      let signatureImgHeight = 'auto';
      for (let i in this.message.reviewContentJson) {
        if (orderNum === this.message.reviewContentJson[i].orderNum) {
          let img = this.message.reviewContentJson[i].signatureImg;
          if (img) {
            signatureImg = img;
            signatureImgHeight = height + 'px'
          }
        }
      }

      return '<img style="height: ' + signatureImgHeight + '" src="' + signatureImg + '"/>';
    },
  }
}
</script>

<style src="./commonTable.css" scoped></style>
<style>
td {
  width: 170px;
}

.diaInner {
  width: 1020px;
  margin: auto;
}

.diainner_title {
  text-align: center;
  font-size: 28px;
  position: relative;
}

.diainner_title .diainner_title_num {
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 14px;
  font-weight: normal;
}

.fireplayidea_title {
  font-size: 14px;
  text-align: left;
  font-weight: bold;
}

.fireplayidea_cont {
  line-height: 22px;
  text-align: left;
  margin: 10px 0;
}

.fireplayidea_right {
  text-align: right;
}

.fireplayidea_right span {
  margin-right: 10px;
  width: 200px;
  display: inline-block;
  text-align: left;
}
</style>
